<template>
    <report-list-view>
        <template slot="tableColumns">
            <veui-table-column field="name" title="子链名称"/>
            <veui-table-column field="url" title="子链URL">
                <template slot-scope="props">
                    <a target="_blank" :href="props.item.url" native>{{props.item.url}}</a>
                </template>
            </veui-table-column>
            <veui-table-column field="pv" title="展现"/>
            <veui-table-column field="click" title="点击"/>
            <veui-table-column field="clickRatioPercent" title="点击率"/>
        </template>
    </report-list-view>
</template>

<script>
import ListView from '../../common/ReportListView';
import createView from '@baidu/ve-ria/views/createView';
import Model from './ListModel';
import {Column} from 'veui';

export default createView(ListView, Model, {
    components: {
        'veui-table-column': Column
    }
});
</script>
